import React from "react"

const Whatsapp = (props) => (
    <a {...props} href="https://wa.me/message/EFYPDIUHNYN4G1" target="_blank noopener noreferrer" title="Chat on Whatsapp" ><i className="icon-whatsapp"/></a>
)

export default Whatsapp